import { BaseApi } from '../apiBase';
import { EventDetails } from '../../types/eventDetails.types';

export class EventDetailsApi extends BaseApi {
  constructor() {
    super('/api/public/events');
  }

  async getDetails(eventSlug: string): Promise<EventDetails> {
    console.log('EventDetailsApi.getDetails called with:', eventSlug);
    const url = `/${eventSlug}/details`;
    console.log('Fetching from URL:', this.baseUrl + url);
    
    try {
      const result = await this.get<EventDetails>(url);
      console.log('EventDetailsApi.getDetails result:', result);
      return result;
    } catch (error) {
      console.error('EventDetailsApi.getDetails error:', error);
      throw error;
    }
  }
}

export const eventDetailsApi = new EventDetailsApi();